// addEvent(window, 'load', );
// initForm();

setTimeout(function() {
	$('#contactForm').validate({
		rules: {
			Field114: { valueNotEquals: "default" }
		},
		messages: {
			SelectName: { valueNotEquals: "Please select an item!" }
		}
	});

	$.validator.addMethod("valueNotEquals", function(value, element, arg){
		return arg !== value;
	}, "Please select a topic.");
}, 2000);
